/**
 * src/app/modules/advance-applications/advance-application-routing.module.ts
 *
 * @author Bryan Henry <bryan@payfully.co>
 * @date 5/11/2021
 * @copyright Payfully, 2021
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
